import { XpIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { globalConst } from 'modules/global';

interface IProps {
  isCorrect: boolean;
  xp?: number;
}

export const XpResult = ({ isCorrect, xp = 0 }: IProps) => {
  const t = useTranslations();

  return (
    <div className="box-border hidden rounded-lg bg-white p-3 max-md:!flex max-md:w-[94%] max-md:items-center max-md:justify-center max-md:shadow">
      {isCorrect ? (
        <div className="flex items-center gap-2">
          <XpIcon />
          <span className="flex items-center text-base font-medium text-green-500">+{xp} XP</span>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <XpIcon fill={globalConst.colors.gray[400]} />
          <span className="text-base font-medium text-gray-400">{t('XP berilmadi')}</span>
        </div>
      )}
    </div>
  );
};
